import { Analytics } from '@cobliteam/analytics/src/Analytics';
import { useTranslation } from '@cobliteam/i18n';
import { Drawer, DrawerBody, DrawerContent, DrawerTitle, DrawerTrigger } from '@cobliteam/ui/components';
import Button from '@cobliteam/ui/components/Button';
import Icon from '@cobliteam/ui/icons';
import AppInfo from '../../../../../../AppInfo/AppInfo';

interface DrawerPageInfoProps {
  supportUID: string;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

const DrawerPageInfo = ({ supportUID, open, onOpenChange }: DrawerPageInfoProps) => {
  const { t } = useTranslation('common');
  const onButtonClick = () => {
    Analytics.track('Page Info - Button Clicked', { supportUID });
  };

  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerTrigger asChild>
        <Button
          variant='outlined'
          icon={<Icon name='info' />}
          color='default'
          size='sm'
          className='relative overflow-hidden rounded-md'
          onClick={onButtonClick}
          aria-label={t('drawerPageInfo.openInfo')}
        />
      </DrawerTrigger>
      <DrawerContent>
        <DrawerBody className='flex h-full flex-1 flex-col px-0 py-2'>
          <DrawerTitle className='hidden' />
          <AppInfo supportUID={supportUID} />
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default DrawerPageInfo;
